module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Dishes-e61f58bfba6ed1ee5f1827c9a1bd03e0.svg";